import { ReferenceListEditor } from "../settings/reference-list-editor";
import { apiCall } from "../../api/client";
import {
  hiringSources,
  type JobSourceShape,
} from "../../api/contracts/hiring-sources";

interface Props {
  sources: JobSourceShape[];
}

export function SourceSettings({ sources }: Props) {
  return (
    <ReferenceListEditor
      title="Application sources"
      description="Where applications come from. Used as the default source value when a candidate applies."
      rows={sources}
      itemNoun="source"
      onCreate={async ({ slug, name }) => {
        await apiCall(hiringSources.create, { body: { slug, name } });
      }}
      onArchive={async (id) => {
        await apiCall(hiringSources.archive, { params: { id } });
      }}
    />
  );
}
